export enum ORDINATION_TYPES {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
  NONE = 'none'
}

export interface OrdinationProps {
  order_by: string;
  order: ORDINATION_TYPES;
}